import { render } from "./SendResultsTab.vue?vue&type=template&id=6bf70efc"
import script from "./SendResultsTab.vue?vue&type=script&lang=js"
export * from "./SendResultsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__